import CustomerContractDetails from "./customer-contract-details";
import CustomerContractsList from "./customer-contract-list";


function CustomerContracts({ customer, customerId, subsubpage }) {
  if(subsubpage) {
    return <CustomerContractDetails customerId={customerId} customer={customer} contractId={subsubpage === 'new' ? 'new' : parseInt(subsubpage)} />
  } else {
    return <CustomerContractsList customerId={customerId} />
  }
}

export default CustomerContracts;